/**
 * A function to create a log object for the 'oneAppTabOpenedInManage' event (evid: 1301)
 *
 * Event description: User opened tab in OneApp Manage section
 *
 * @param {oneAppTabOpenedInManageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - tab name opened in Manage
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppTabOpenedInManageParams>} LogObject<oneAppTabOpenedInManageParams>
 */
export function oneAppTabOpenedInManage(params) {
    return { evid: 1301, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppPostSwipeAction' event (evid: 1303)
 *
 * Event description: User did a swipe action in OneApp
 *
 * @param {oneAppPostSwipeActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} tab_name - tab name in Manage (Published/Drafts)
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {string} origin - Manage
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - is_published
 * @return {LogObject<oneAppPostSwipeActionParams>} LogObject<oneAppPostSwipeActionParams>
 */
export function oneAppPostSwipeAction(params) {
    return { evid: 1303, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppClickInsideSwipeAction' event (evid: 1304)
 *
 * Event description: User chose action after swipe
 *
 * @param {oneAppClickInsideSwipeActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - stable id
 * @property {string} origin - OneApp Manage
 * @property {GUID} msid - msid
 * @property {string} action - Settings/Edit
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<oneAppClickInsideSwipeActionParams>} LogObject<oneAppClickInsideSwipeActionParams>
 */
export function oneAppClickInsideSwipeAction(params) {
    return { evid: 1304, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageFilterPostsClick' event (evid: 1305)
 *
 * Event description: Click on filter post in OneApp (to choose your own or written by others posts)
 *
 * @param {oneAppManageFilterPostsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - Published/Dratfs
 * @property {string} filter - Which filter in Wix App is used: Analytics/posts/drafts
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageFilterPostsClickParams>} LogObject<oneAppManageFilterPostsClickParams>
 */
export function oneAppManageFilterPostsClick(params) {
    return { evid: 1305, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageFilterPostsSaveClick' event (evid: 1306)
 *
 * Event description: Click on filter post in OneApp (to choose your own or written by others posts)
 *
 * @param {oneAppManageFilterPostsSaveClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} filter - Which filter in Wix App is used: Analytics/posts/drafts
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} filter_name - "My Posts"/"Posts by Others"/"All Posts"
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageFilterPostsSaveClickParams>} LogObject<oneAppManageFilterPostsSaveClickParams>
 */
export function oneAppManageFilterPostsSaveClick(params) {
    return { evid: 1306, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageSearchClicked' event (evid: 1307)
 *
 * Event description: After clicking on search in OneApp manage
 *
 * @param {oneAppManageSearchClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageSearchClickedParams>} LogObject<oneAppManageSearchClickedParams>
 */
export function oneAppManageSearchClicked(params) {
    return { evid: 1307, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneappManageSearchTextEntered' event (evid: 1308)
 *
 * Event description: After text was entered in search
 *
 * @param {oneappManageSearchTextEnteredParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneappManageSearchTextEnteredParams>} LogObject<oneappManageSearchTextEnteredParams>
 */
export function oneappManageSearchTextEntered(params) {
    return { evid: 1308, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneappManageSearchResults' event (evid: 1309)
 *
 * Event description: Number of posts found in search in OneApp Manage
 *
 * @param {oneappManageSearchResultsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {number} num_posts_found - Number of posts found in search
 * @property {GUID} msid - msid
 * @return {LogObject<oneappManageSearchResultsParams>} LogObject<oneappManageSearchResultsParams>
 */
export function oneappManageSearchResults(params) {
    return { evid: 1309, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesThreeDotsClick' event (evid: 1310)
 *
 * Event description: Number of posts found in search in OneApp Manage
 *
 * @param {oneAppManageCategoriesThreeDotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category_id
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesThreeDotsClickParams>} LogObject<oneAppManageCategoriesThreeDotsClickParams>
 */
export function oneAppManageCategoriesThreeDotsClick(params) {
    return { evid: 1310, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesButtonInThreeDotsClicked' event (evid: 1311)
 *
 * Event description: Button in categories three dots meniu clicked
 *
 * @param {oneAppManageCategoriesButtonInThreeDotsClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} button_name - button name in three dots categories menu
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category_id
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesButtonInThreeDotsClickedParams>} LogObject<oneAppManageCategoriesButtonInThreeDotsClickedParams>
 */
export function oneAppManageCategoriesButtonInThreeDotsClicked(params) {
    return { evid: 1311, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesAddNewCategoryClick' event (evid: 1312)
 *
 * Event description: Clicked on add new category button in OneApp
 *
 * @param {oneAppManageCategoriesAddNewCategoryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesAddNewCategoryClickParams>} LogObject<oneAppManageCategoriesAddNewCategoryClickParams>
 */
export function oneAppManageCategoriesAddNewCategoryClick(params) {
    return { evid: 1312, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppManageCategoriesEditCategoryOpened' event (evid: 1313)
 *
 * Event description: Clicked on add new category button in OneApp
 *
 * @param {oneAppManageCategoriesEditCategoryOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category_id
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppManageCategoriesEditCategoryOpenedParams>} LogObject<oneAppManageCategoriesEditCategoryOpenedParams>
 */
export function oneAppManageCategoriesEditCategoryOpened(params) {
    return { evid: 1313, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppSharePostCopyUrlClick' event (evid: 1314)
 *
 * Event description: user copied url to clipboard (clicked share post)
 *
 * @param {oneAppSharePostCopyUrlClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - after publish
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSharePostCopyUrlClickParams>} LogObject<oneAppSharePostCopyUrlClickParams>
 */
export function oneAppSharePostCopyUrlClick(params) {
    return { evid: 1314, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppHappyMomentBanners' event (evid: 1315)
 *
 * Event description: User did an action with a banner in Blog Manage
 *
 * @param {oneAppHappyMomentBannersParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} banner_name - banner name - add banner to mobile, share your blog
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @property {string} action - closed, CTA - add banner, CTA - share
 * @return {LogObject<oneAppHappyMomentBannersParams>} LogObject<oneAppHappyMomentBannersParams>
 */
export function oneAppHappyMomentBanners(params) {
    return { evid: 1315, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppSharePostButtonClick' event (evid: 1316)
 *
 * Event description: user clicked on share button in oneapp top bar
 *
 * @param {oneAppSharePostButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page, view post etc.
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppSharePostButtonClickParams>} LogObject<oneAppSharePostButtonClickParams>
 */
export function oneAppSharePostButtonClick(params) {
    return { evid: 1316, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppOpenedAllPostsAnalytics' event (evid: 1318)
 *
 * Event description: Whenever a user opens Post Analytics (all posts)
 *
 * @param {oneAppOpenedAllPostsAnalyticsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - user role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} filter_name - The analytics Period (1D, 7D, 28D, all time)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppOpenedAllPostsAnalyticsParams>} LogObject<oneAppOpenedAllPostsAnalyticsParams>
 */
export function oneAppOpenedAllPostsAnalytics(params) {
    return { evid: 1318, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppWixReadsScreenOpen' event (evid: 1319)
 *
 * Event description: triggered when user sees the home or the explore tabs in wix reads
 *
 * @param {oneAppWixReadsScreenOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - holds the child app (forum/blog) instance_id. or the members instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} screenName - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site member id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppWixReadsScreenOpenParams>} LogObject<oneAppWixReadsScreenOpenParams>
 */
export function oneAppWixReadsScreenOpen(params) {
    return { evid: 1319, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppGenericModalShown' event (evid: 1320)
 *
 * Event description: Modal shown - generic event for many different modals.
 *
 * @param {oneAppGenericModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - the previous screen/modal
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppGenericModalShownParams>} LogObject<oneAppGenericModalShownParams>
 */
export function oneAppGenericModalShown(params) {
    return { evid: 1320, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppModalOptionClick' event (evid: 1321)
 *
 * Event description: Generic event to track clicks within a modal in OneApp
 *
 * @param {oneAppModalOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} action_name - the option the user clicked / selected on the modal
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - the previous screen/modal
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppModalOptionClickParams>} LogObject<oneAppModalOptionClickParams>
 */
export function oneAppModalOptionClick(params) {
    return { evid: 1321, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppActionSheetOptionClick' event (evid: 1323)
 *
 * Event description: Generic event to track clicks within an action sheet in OneApp
 *
 * @param {oneAppActionSheetOptionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} action_name - the option the user clicked / selected on the modal
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} action_sheet_name - action name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - what triggered this action
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppActionSheetOptionClickParams>} LogObject<oneAppActionSheetOptionClickParams>
 */
export function oneAppActionSheetOptionClick(params) {
    return { evid: 1323, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppGenericActionSheetShown' event (evid: 1324)
 *
 * Event description: Action sheet showed - a generic event for many different action sheets.
 *
 * @param {oneAppGenericActionSheetShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} visitor_id - visitor
 * @property {string} action_sheet_name - action sheet name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - the previous screen/modal
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppGenericActionSheetShownParams>} LogObject<oneAppGenericActionSheetShownParams>
 */
export function oneAppGenericActionSheetShown(params) {
    return { evid: 1324, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppConnectPlanToPost' event (evid: 1325)
 *
 * Event description: triggered in OneApp when the user connects a plan to a post(s)
 *
 * @param {oneAppConnectPlanToPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_ids - Array of posts
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} translation_id - translation id
 * @property {string} paid_plan_id - Array paid plan Ids
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppConnectPlanToPostParams>} LogObject<oneAppConnectPlanToPostParams>
 */
export function oneAppConnectPlanToPost(params) {
    return { evid: 1325, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppGenericButtonClick' event (evid: 1326)
 *
 * Event description: the user clicked on a button
 *
 * @param {oneAppGenericButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} button_name - the button name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppGenericButtonClickParams>} LogObject<oneAppGenericButtonClickParams>
 */
export function oneAppGenericButtonClick(params) {
    return { evid: 1326, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppCustomizeBlogSections' event (evid: 1327)
 *
 * Event description: When a user clicks customize from the admin menu on the blog tab. One app only!
 *
 * @param {oneAppCustomizeBlogSectionsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tab_name - tab name (member view or place card)
 * @property {string} section - which section is being edited. (header, navigation tabs, category list etc..)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} property_value - The setting value
 * @property {string} app_id - app_id
 * @property {string} property - The setting name
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppCustomizeBlogSectionsParams>} LogObject<oneAppCustomizeBlogSectionsParams>
 */
export function oneAppCustomizeBlogSections(params) {
    return { evid: 1327, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'followUnfollowCategoryClickWixReads' event (evid: 1328)
 *
 * Event description: When the user clicks to follow or unfollow
 *
 * @param {followUnfollowCategoryClickWixReadsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_name - category name
 * @property {boolean} is_followed - 1- followed, 0 - unfollowed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} category_id - category id
 * @property {GUID} msid - msid
 * @return {LogObject<followUnfollowCategoryClickWixReadsParams>} LogObject<followUnfollowCategoryClickWixReadsParams>
 */
export function followUnfollowCategoryClickWixReads(params) {
    return { evid: 1328, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'customizeChooseCategoriesClickWixReads' event (evid: 1329)
 *
 * Event description: When the user clicks on the Customise or Choose now links on the main screen on wix reads, that link will take the user to the "Edit Categories" screen
 *
 * @param {customizeChooseCategoriesClickWixReadsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - choose now, customise
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<customizeChooseCategoriesClickWixReadsParams>} LogObject<customizeChooseCategoriesClickWixReadsParams>
 */
export function customizeChooseCategoriesClickWixReads(params) {
    return { evid: 1329, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppCategoryPage3DotsClick' event (evid: 1330)
 *
 * Event description: When the user clicks on the 3 dots button on the category page in OneApp
 *
 * @param {oneAppCategoryPage3DotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - category page
 * @property {string} category_id - category_id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppCategoryPage3DotsClickParams>} LogObject<oneAppCategoryPage3DotsClickParams>
 */
export function oneAppCategoryPage3DotsClick(params) {
    return { evid: 1330, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppBlogPageSettingsScreenOpened' event (evid: 1331)
 *
 * Event description: User opens the blog Page screen settings
 *
 * @param {oneAppBlogPageSettingsScreenOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - from where did the user get to this screen
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogPageSettingsScreenOpenedParams>} LogObject<oneAppBlogPageSettingsScreenOpenedParams>
 */
export function oneAppBlogPageSettingsScreenOpened(params) {
    return { evid: 1331, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppBlogPageSettingsChanged' event (evid: 1332)
 *
 * Event description: User opens the blog Page screen settings
 *
 * @param {oneAppBlogPageSettingsChangedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - Post or Category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - from where did the user get to this screen
 * @property {string} property_value - property value
 * @property {string} property - property
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogPageSettingsChangedParams>} LogObject<oneAppBlogPageSettingsChangedParams>
 */
export function oneAppBlogPageSettingsChanged(params) {
    return { evid: 1332, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppEditCategory' event (evid: 1333)
 *
 * Event description: User edited a category
 *
 * @param {oneAppEditCategoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} category_image - category image
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_name - category label
 * @property {string} category_description - category description
 * @property {string} categoryTitle - category title
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - from where did the user get to this screen
 * @property {string} category_id - category id
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppEditCategoryParams>} LogObject<oneAppEditCategoryParams>
 */
export function oneAppEditCategory(params) {
    return { evid: 1333, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppBlogOnboardingStepsButtonClick' event (evid: 1334)
 *
 * Event description: The user clicked a button on the onboarding
 *
 * @param {oneAppBlogOnboardingStepsButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} step_name - add your first post, invite members etc..
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} button_name - add post, skip, undo etc...
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - manage blog
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogOnboardingStepsButtonClickParams>} LogObject<oneAppBlogOnboardingStepsButtonClickParams>
 */
export function oneAppBlogOnboardingStepsButtonClick(params) {
    return { evid: 1334, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppBlogSearchClicked' event (evid: 1335)
 *
 * Event description: After clicking on search in OneApp blog home
 *
 * @param {oneAppBlogSearchClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogSearchClickedParams>} LogObject<oneAppBlogSearchClickedParams>
 */
export function oneAppBlogSearchClicked(params) {
    return { evid: 1335, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneappBlogSearchTextEntered' event (evid: 1336)
 *
 * Event description: After text was entered in search
 *
 * @param {oneappBlogSearchTextEnteredParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tab_name - Posts, Categories, Authors, Tags
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {GUID} msid - msid
 * @return {LogObject<oneappBlogSearchTextEnteredParams>} LogObject<oneappBlogSearchTextEnteredParams>
 */
export function oneappBlogSearchTextEntered(params) {
    return { evid: 1336, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppBlogSearchResultClicked' event (evid: 1338)
 *
 * Event description: After clicking on search in OneApp blog home
 *
 * @param {oneAppBlogSearchResultClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id
 * @property {string} tagid - tag id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where tabs was opened (Manage)
 * @property {string} category_id - category id
 * @property {GUID} author_id - author id
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppBlogSearchResultClickedParams>} LogObject<oneAppBlogSearchResultClickedParams>
 */
export function oneAppBlogSearchResultClicked(params) {
    return { evid: 1338, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppPreviousNextPostArrowClick' event (evid: 1339)
 *
 * Event description: the user clicked on the previous or next post within the post page
 *
 * @param {oneAppPreviousNextPostArrowClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page
 * @property {GUID} msid - msid
 * @property {string} action - previous or next post
 * @return {LogObject<oneAppPreviousNextPostArrowClickParams>} LogObject<oneAppPreviousNextPostArrowClickParams>
 */
export function oneAppPreviousNextPostArrowClick(params) {
    return { evid: 1339, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppWidgetClick' event (evid: 1340)
 *
 * Event description: Tracks what the user clicked on any widget on the app
 *
 * @param {oneAppWidgetClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} click_name - the label on the object clicked
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id - null if the click was not on a post
 * @property {string} widget_name - widget name
 * @property {GUID} post_stable_id - post stable id - null if the click was not on a post
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppWidgetClickParams>} LogObject<oneAppWidgetClickParams>
 */
export function oneAppWidgetClick(params) {
    return { evid: 1340, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppPostPreview' event (evid: 1341)
 *
 * Event description: Triggered when user previews a post on the owners app
 *
 * @param {oneAppPostPreviewParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where was the preview triggered: post list, post editor
 * @property {string} preview_type - the preview type: desktop, mobile browser, wix app
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppPostPreviewParams>} LogObject<oneAppPostPreviewParams>
 */
export function oneAppPostPreview(params) {
    return { evid: 1341, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppReportPostClick' event (evid: 1342)
 *
 * Event description: event for reporting a post in OneApp
 *
 * @param {oneAppReportPostClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - site_member role
 * @property {string} post_id - post_id of the reported post
 * @property {GUID} post_stable_id - post_stable_id of the reported post
 * @property {string} origin - where the report click happened from (currently only under three dots)
 * @property {GUID} msid - msid
 * @return {LogObject<oneAppReportPostClickParams>} LogObject<oneAppReportPostClickParams>
 */
export function oneAppReportPostClick(params) {
    return { evid: 1342, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogCardShown' event (evid: 1343)
 *
 * Event description: When a specific card is shown in Blog, e.g. regarding WP import status
 *
 * @param {blogCardShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} values_json - what is shown in the card
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} card_name - name of the card, e.g.: "post_importer"
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<blogCardShownParams>} LogObject<blogCardShownParams>
 */
export function blogCardShown(params) {
    return { evid: 1343, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'actionInsideBlogCard' event (evid: 1344)
 *
 * Event description: When an action is clicked inside Blog card, e.g. in WP importer status card.
 *
 * @param {actionInsideBlogCardParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} card_name - card_name
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} action - "view_posts_to_copy"/"contact_support"
 * @return {LogObject<actionInsideBlogCardParams>} LogObject<actionInsideBlogCardParams>
 */
export function actionInsideBlogCard(params) {
    return { evid: 1344, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'ratingsCommentsToggleInBlogBm' event (evid: 1348)
 *
 * Event description: When Ratings or Comments are toggled on/off in Blog BM settings.
 *
 * @param {ratingsCommentsToggleInBlogBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} toggle - true/false
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} type - comments/ratings
 * @property {GUID} msid - msid
 * @return {LogObject<ratingsCommentsToggleInBlogBmParams>} LogObject<ratingsCommentsToggleInBlogBmParams>
 */
export function ratingsCommentsToggleInBlogBm(params) {
    return { evid: 1348, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'ratingsCommentsSubToggleInBlogBm' event (evid: 1349)
 *
 * Event description: When a sub-toggle is chosen in Ratings / Comments settings in Blog BM.
 *
 * @param {ratingsCommentsSubToggleInBlogBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} toggle - true/false
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} type - ratings/comments
 * @property {GUID} msid - msid
 * @property {string} value - members_only/everyone/ratings_mandatory
 * @return {LogObject<ratingsCommentsSubToggleInBlogBmParams>} LogObject<ratingsCommentsSubToggleInBlogBmParams>
 */
export function ratingsCommentsSubToggleInBlogBm(params) {
    return { evid: 1349, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualAutoTranslateSuccess' event (evid: 1351)
 *
 * Event description: When user finishes auto translating
 *
 * @param {multilingualAutoTranslateSuccessParams} params - The parameters for this event
 * @property {GUID} instance_id - blog instance_id
 * @property {GUID} biToken - msid
 * @property {string} selected_langauge - the selected language
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} original_language - the original language of post
 * @property {number} credits_required - how many credits were required to translate the post
 * @property {number} credits_after - how many credits were available after the translation
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where the autotranslate happened from: post_list/post_editor
 * @property {number} credits_before - how many credits were available before the translation
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualAutoTranslateSuccessParams>} LogObject<multilingualAutoTranslateSuccessParams>
 */
export function multilingualAutoTranslateSuccess(params) {
    return { evid: 1351, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualError' event (evid: 1352)
 *
 * Event description: When a user encounters a multilingual related error
 *
 * @param {multilingualErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} errorMessage - the message which is displayed in the error
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualErrorParams>} LogObject<multilingualErrorParams>
 */
export function multilingualError(params) {
    return { evid: 1352, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualPostEditorAddTranslationClick' event (evid: 1353)
 *
 * Event description: When a user clicks on add translation in post editor
 *
 * @param {multilingualPostEditorAddTranslationClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualPostEditorAddTranslationClickParams>} LogObject<multilingualPostEditorAddTranslationClickParams>
 */
export function multilingualPostEditorAddTranslationClick(params) {
    return { evid: 1353, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'threeDotsClickInTagTab' event (evid: 1354)
 *
 * Event description: When a user clicks three dots in a tag tab in blog manager
 *
 * @param {threeDotsClickInTagTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - the stable id for tags
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tagid - tag_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @return {LogObject<threeDotsClickInTagTabParams>} LogObject<threeDotsClickInTagTabParams>
 */
export function threeDotsClickInTagTab(params) {
    return { evid: 1354, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'actionInsideThreeDotsClickInTagTab' event (evid: 1355)
 *
 * Event description: When a user clicks three dots in a tag tab in blog manager
 *
 * @param {actionInsideThreeDotsClickInTagTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - the stable id for tags
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tagid - tag_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag name
 * @property {string} action - action
 * @return {LogObject<actionInsideThreeDotsClickInTagTabParams>} LogObject<actionInsideThreeDotsClickInTagTabParams>
 */
export function actionInsideThreeDotsClickInTagTab(params) {
    return { evid: 1355, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'monetizationTabClick' event (evid: 1356)
 *
 * Event description: All of the clicks inside of monetization tab
 *
 * @param {monetizationTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - name of the click
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} parent_name - tools/video/articles
 * @property {string} additional_info - json with additional info, e.g. article link
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<monetizationTabClickParams>} LogObject<monetizationTabClickParams>
 */
export function monetizationTabClick(params) {
    return { evid: 1356, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogNotificationShown' event (evid: 1357)
 *
 * Event description: When a notification in Blog is being shown
 *
 * @param {blogNotificationShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where a notification is being shown
 * @property {string} content - what is written in the notification
 * @property {GUID} msid - msid
 * @return {LogObject<blogNotificationShownParams>} LogObject<blogNotificationShownParams>
 */
export function blogNotificationShown(params) {
    return { evid: 1357, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogNotificationButtonClick' event (evid: 1358)
 *
 * Event description: When a button is clicked in the blog notification
 *
 * @param {blogNotificationButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} button_name - button_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - where the notification was shown
 * @property {string} content - what is written in the notification
 * @property {GUID} msid - msid
 * @return {LogObject<blogNotificationButtonClickParams>} LogObject<blogNotificationButtonClickParams>
 */
export function blogNotificationButtonClick(params) {
    return { evid: 1358, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'reinstallationModalShown' event (evid: 1359)
 *
 * Event description: When a Blog reinstallation modal is shown in Editor.
 *
 * @param {reinstallationModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} entryPoint - from where the installation was triggered
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<reinstallationModalShownParams>} LogObject<reinstallationModalShownParams>
 */
export function reinstallationModalShown(params) {
    return { evid: 1359, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'reinstallationModalAction' event (evid: 1360)
 *
 * Event description: When a user clicks on the reinstallation modal in Editor.
 *
 * @param {reinstallationModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - what was chosen in the modal
 * @return {LogObject<reinstallationModalActionParams>} LogObject<reinstallationModalActionParams>
 */
export function reinstallationModalAction(params) {
    return { evid: 1360, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'categoriesTabGenericAction' event (evid: 1365)
 *
 * Event description: Clicks inside categories tab
 *
 * @param {categoriesTabGenericActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} category_id - category_id
 * @property {GUID} msid - msid
 * @property {string} action - action
 * @return {LogObject<categoriesTabGenericActionParams>} LogObject<categoriesTabGenericActionParams>
 */
export function categoriesTabGenericAction(params) {
    return { evid: 1365, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'categoriesTabBulkAction' event (evid: 1366)
 *
 * Event description: Categories tab bulk action
 *
 * @param {categoriesTabBulkActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} category_ids - json with selected categories
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - what action was done
 * @return {LogObject<categoriesTabBulkActionParams>} LogObject<categoriesTabBulkActionParams>
 */
export function categoriesTabBulkAction(params) {
    return { evid: 1366, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogManagerOpenClickBo' event (evid: 300)
 *
 * Event description: triggered when click on Manage posts CTA
 *
 * @param {blogManagerOpenClickBoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogManagerOpenClickBoParams>} LogObject<blogManagerOpenClickBoParams>
 */
export function blogManagerOpenClickBo(params) {
    return { evid: 300, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogManagerOpenedBo' event (evid: 301)
 *
 * Event description: triggered when blog manager actually open!
 *
 * @param {blogManagerOpenedBoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {string} version - the biz manager version (null values mean the v1)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - the language if ML
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} referrer - the place from which it was open
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {string} destination - blog manager destination name
 * @property {string} tab_name - tab_name
 * @return {LogObject<blogManagerOpenedBoParams>} LogObject<blogManagerOpenedBoParams>
 */
export function blogManagerOpenedBo(params) {
    return { evid: 301, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postPublished' event (evid: 303)
 *
 * Event description: triggered when post: Created(Published), Updated, Unpublished, Moved to trash, Deleted,
 *
 * @param {postPublishedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} url - the post url
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {string} tag_ids - array of tags
 * @property {number} categories_count - NOT IN USE: categories_count that post was assigned to
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - The number of characters on the post
 * @property {string} original_post_id - the original post id
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} author_id - author id
 * @property {string} paid_plan_id - Array of paid plan ids
 * @property {string} member_id - member_id
 * @property {number} video_count - video_count in the post
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @property {string} related_post_ids - array with related post Ids
 * @return {LogObject<postPublishedParams>} LogObject<postPublishedParams>
 */
export function postPublished(params) {
    return { evid: 303, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postDraftCreated' event (evid: 305)
 *
 * Event description: triggered when a post draft is created (first save)
 *
 * @param {postDraftCreatedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} is_offline - if the event happened offline
 * @property {string} translation_id - the post_stable_id of the translated post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @property {string} template_id - post template id
 * @return {LogObject<postDraftCreatedParams>} LogObject<postDraftCreatedParams>
 */
export function postDraftCreated(params) {
    return { evid: 305, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postDeleted' event (evid: 306)
 *
 * Event description: triggered when post deleted
 *
 * @param {postDeletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} translation_id - translation id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postDeletedParams>} LogObject<postDeletedParams>
 */
export function postDeleted(params) {
    return { evid: 306, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postEditorOpened' event (evid: 307)
 *
 * Event description: triggered when post editor opened
 *
 * @param {postEditorOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} translatation_id - the post_stable_id of the translated post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - to be used in multilingual context.
 * @property {number} character_count - character count in post (sends only on Web)
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - NOT IN USE: in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} referrer - the place from which it was opened
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<postEditorOpenedParams>} LogObject<postEditorOpenedParams>
 */
export function postEditorOpened(params) {
    return { evid: 307, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'writeNewPostClick' event (evid: 308)
 *
 * Event description: triggered when click on write new post CTA
 *
 * @param {writeNewPostClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<writeNewPostClickParams>} LogObject<writeNewPostClickParams>
 */
export function writeNewPostClick(params) {
    return { evid: 308, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postPageWidthOfPostChanged' event (evid: 309)
 *
 * Event description: Width of post changed in post page
 * width field itself is not very trustful, as it's calculated the other way around if "full width" is enabled and we can't know if it's enabled
 *
 * @param {postPageWidthOfPostChangedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} buildertype - In which editor changed was made: mobile, desktop
 * @property {string} role - role
 * @property {string} referral_info - not working: referral_info
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} eventmeta - eventmeta
 * @property {string} origin - editor
 * @property {GUID} msid - msid
 * @property {number} width - width of post after change (not very trustful, as there are some mismatches with enabled full width)
 * @return {LogObject<postPageWidthOfPostChangedParams>} LogObject<postPageWidthOfPostChangedParams>
 */
export function postPageWidthOfPostChanged(params) {
    return { evid: 309, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'newCategoryAddedToBlog' event (evid: 311)
 *
 * Event description: triggered when a new category added in the app settings
 *
 * @param {newCategoryAddedToBlogParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} seo_description - category description in seo settings was added (OneApp only)
 * @property {string} role - member role (owner, writer, member)
 * @property {boolean} image - image for category was added (OneApp only)
 * @property {string} label - the category name
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {number} category_count - current amount of categories i the blog
 * @property {boolean} seo_name - category name was under seo settings (OneApp only)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - The category language
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor, avdanced_post_settings
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} category_id - category_id
 * @property {string} translation_id - the Id of category that was translated
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<newCategoryAddedToBlogParams>} LogObject<newCategoryAddedToBlogParams>
 */
export function newCategoryAddedToBlog(params) {
    return { evid: 311, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogCategoryInfoChanged' event (evid: 312)
 *
 * Event description: triggered when an exiting category edited in the app settings - title or description
 *
 * @param {blogCategoryInfoChangedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} seo_description - seo_description was edited (OneApp only)
 * @property {string} role - member role (owner, writer, member)
 * @property {boolean} image - image was edited (OneApp only)
 * @property {string} referral_info - external links - facebook, social networks. if from wix then null
 * @property {number} category_count - current amount of categories i the blog
 * @property {boolean} seo_name - seo_name was changed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} category_id - category_id
 * @property {string} translation_id - the id of the the translated category
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {boolean} category_label - category label was changed
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogCategoryInfoChangedParams>} LogObject<blogCategoryInfoChangedParams>
 */
export function blogCategoryInfoChanged(params) {
    return { evid: 312, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'draftSaved' event (evid: 313)
 *
 * Event description: triggered when a post draft is saved each time (Web Only)
 *
 * @param {draftSavedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_title - post title
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - Character count in post
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} msid - msid
 * @return {LogObject<draftSavedParams>} LogObject<draftSavedParams>
 */
export function draftSaved(params) {
    return { evid: 313, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'tagCreated' event (evid: 314)
 *
 * Event description: triggered whenever the user removes a tag from the post.
 *
 * @param {tagCreatedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - tag stable id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tagid - tag_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag label
 * @return {LogObject<tagCreatedParams>} LogObject<tagCreatedParams>
 */
export function tagCreated(params) {
    return { evid: 314, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'shareAfterPublishModalShown' event (evid: 315)
 *
 * Event description: Share after publish modal shown for user
 *
 * @param {shareAfterPublishModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post_id
 * @property {string} possible_modal_actions - possible_modal_actions
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<shareAfterPublishModalShownParams>} LogObject<shareAfterPublishModalShownParams>
 */
export function shareAfterPublishModalShown(params) {
    return { evid: 315, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'shareAfterPublishModalAction' event (evid: 316)
 *
 * Event description: User chose action in Share after publish modal
 *
 * @param {shareAfterPublishModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} dont_show_again - user marked don't show again
 * @property {GUID} msid - msid
 * @property {string} action - action user chose in modal (Not right now, close X, Facebook, Preview, Twitter, copy url, etc)
 * @return {LogObject<shareAfterPublishModalActionParams>} LogObject<shareAfterPublishModalActionParams>
 */
export function shareAfterPublishModalAction(params) {
    return { evid: 316, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'fileUploaded' event (evid: 317)
 *
 * Event description: Event triggered when a person tries to upload a file to a Blog post
 *
 * @param {fileUploadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - metasite id
 * @property {boolean} is_demo - is_demo
 * @property {string} file_ext - File extension
 * @property {boolean} success - 0 - upload failed / 1 - upload successful
 * @property {string} screen_name - screen_name
 * @property {string} file_id - The file identifier (null if not successful)
 * @property {string} role - role
 * @property {number} file_size - The size of the file being uploaded (in bytes)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} mime_type - File type
 * @property {string} origin - post (for now just post)
 * @property {GUID} msid - metasite id
 * @return {LogObject<fileUploadedParams>} LogObject<fileUploadedParams>
 */
export function fileUploaded(params) {
    return { evid: 317, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postFeedFilterSettingsCategoryAndTags' event (evid: 318)
 *
 * Event description: Whenever a user selects a filter for the post list from the settings button.
 *
 * @param {postFeedFilterSettingsCategoryAndTagsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} tag_guid - tag stable id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tagid - tag_id, null if user selected all posts
 * @property {string} category_name - category name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} category_id - category Id
 * @property {GUID} category_stable_id - category stable id
 * @property {GUID} msid - msid
 * @property {string} tag_name - tag label
 * @return {LogObject<postFeedFilterSettingsCategoryAndTagsParams>} LogObject<postFeedFilterSettingsCategoryAndTagsParams>
 */
export function postFeedFilterSettingsCategoryAndTags(params) {
    return { evid: 318, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blog6thButtonBlogElementAdded' event (evid: 322)
 *
 * Event description: triggered when adding blog element from the blog 6th button
 *
 * @param {blog6thButtonBlogElementAddedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} widget_id - widget_id
 * @property {number} ts - dummy
 * @property {string} viewmode - dummy
 * @property {GUID} id - unique id of a widget to connect to other events
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - 6th button or Add panel
 * @property {string} editor_working_mode - dummy
 * @property {string} pageType - the page the widget was added on. Home, Post, other
 * @property {string} element_type - recent post, custom feed
 * @property {string} layout - layout of the element that was added
 * @property {GUID} esi - dummy
 * @property {boolean} is_first_time_view - dummy
 * @property {GUID} msid - msid
 * @return {LogObject<blog6thButtonBlogElementAddedParams>} LogObject<blog6thButtonBlogElementAddedParams>
 */
export function blog6thButtonBlogElementAdded(params) {
    return { evid: 322, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsDoneClick' event (evid: 323)
 *
 * Event description: Clicking Done in advance post settings
 *
 * @param {advancedPostSettingsDoneClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {boolean} is_changed_search_engine_title - Changed search engine title
 * @property {string} screen_name - screen_name
 * @property {string} language_id - language
 * @property {boolean} is_excerpt_written - 1 - added text, 0 - didn't
 * @property {string} role - Role of user - writer or admin
 * @property {string} post_id - post_id
 * @property {boolean} is_on_feature_post_toggle - 1 - on, 0 - off
 * @property {string} button_name - Save, Save and Publish
 * @property {boolean} is_publish_date_edited - Post publish date edited
 * @property {boolean} is_author_changed - User changed author
 * @property {number} categories_chosen - How many categories was chosen
 * @property {boolean} is_written_description - Written a description
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} is_feature_post_toggle_changed - If toggle was changed
 * @property {boolean} is_main_category_changed - if user changed the main category
 * @property {string} translation_id - translation
 * @property {boolean} is_changed_excerpt - If excerpt was changed
 * @property {string} platform - Was opened in back office/live site
 * @property {boolean} is_changed_url - Changed URL
 * @property {GUID} msid - msid
 * @property {boolean} is_cover_image_changed - Changed cover image
 * @property {boolean} is_category_changed - if the user added or removed categories from the post
 * @property {boolean} is_display_cover_toggle_changed - If toggle was changed
 * @property {boolean} is_published - Is post published (1-published)
 * @property {boolean} is_on_display_cover_toggle - 1 - on, 0 - off
 * @return {LogObject<advancedPostSettingsDoneClickParams>} LogObject<advancedPostSettingsDoneClickParams>
 */
export function advancedPostSettingsDoneClick(params) {
    return { evid: 323, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsTabOpen' event (evid: 324)
 *
 * Event description: Left sidebar tab opened in post editor
 *
 * @param {advancedPostSettingsTabOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post id
 * @property {string} tab_name - Which tab was opened in post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} platform - Where event took place - live site or business manager
 * @property {GUID} msid - msid
 * @property {string} origin - used with AI tools - what is the origin the tab was opened from
 * @return {LogObject<advancedPostSettingsTabOpenParams>} LogObject<advancedPostSettingsTabOpenParams>
 */
export function advancedPostSettingsTabOpen(params) {
    return { evid: 324, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogTabInBmOpened' event (evid: 325)
 *
 * Event description: Tab in Blog Manager opened
 *
 * @param {blogTabInBmOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {string} name - Opened Tab name in Blog Back Office
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {string} tab_name - Opened Tab in Blog Back Office
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - the language that was rendered
 * @property {string} place - Place where tab was opened (sidebar / blog posts list)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} referrer - from which place it was opened
 * @property {GUID} msid - msid
 * @property {string} sub_tab - sub_tab
 * @return {LogObject<blogTabInBmOpenedParams>} LogObject<blogTabInBmOpenedParams>
 */
export function blogTabInBmOpened(params) {
    return { evid: 325, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'adiBlogSettingsOpened' event (evid: 326)
 *
 * Event description: User opened blog settings in ADI
 *
 * @param {adiBlogSettingsOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} adi_blog_settings_opened - 1 - ADI Blog settings opened
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<adiBlogSettingsOpenedParams>} LogObject<adiBlogSettingsOpenedParams>
 */
export function adiBlogSettingsOpened(params) {
    return { evid: 326, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'adiBlogSettingsToggleClick' event (evid: 327)
 *
 * Event description: Which settings user chose on Settings panel in ADI
 *
 * @param {adiBlogSettingsToggleClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} is_enabled - 1 - enabled, 0 - disabled
 * @property {string} toggle_name - Name of the toggle in blog settings
 * @property {GUID} msid - msid
 * @return {LogObject<adiBlogSettingsToggleClickParams>} LogObject<adiBlogSettingsToggleClickParams>
 */
export function adiBlogSettingsToggleClick(params) {
    return { evid: 327, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'advancedPostSettingsOpen' event (evid: 328)
 *
 * Event description: Advanced post settings opened
 *
 * @param {advancedPostSettingsOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - MSID
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} platform - Was opened in back office/live site
 * @property {GUID} msid - MSID
 * @property {boolean} is_published - Is post published (1-published)
 * @return {LogObject<advancedPostSettingsOpenParams>} LogObject<advancedPostSettingsOpenParams>
 */
export function advancedPostSettingsOpen(params) {
    return { evid: 328, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'addBlogAppDisplayTypeOfBlogModal' event (evid: 329)
 *
 * Event description: Whenever the user adds the blog app to a site. This event records if the type of blog modal was displayed.
 *
 * @param {addBlogAppDisplayTypeOfBlogModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<addBlogAppDisplayTypeOfBlogModalParams>} LogObject<addBlogAppDisplayTypeOfBlogModalParams>
 */
export function addBlogAppDisplayTypeOfBlogModal(params) {
    return { evid: 329, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'addBlogAppTypeOfBlogModalSelection' event (evid: 330)
 *
 * Event description: Whenever the user adds the blog app to a site, the type of modal is displayed. This event records the user selection on the type of blog modal.
 *
 * @param {addBlogAppTypeOfBlogModalSelectionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} option - values: wix blog or members area
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - close or next
 * @return {LogObject<addBlogAppTypeOfBlogModalSelectionParams>} LogObject<addBlogAppTypeOfBlogModalSelectionParams>
 */
export function addBlogAppTypeOfBlogModalSelection(params) {
    return { evid: 330, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postsBm3Dots' event (evid: 331)
 *
 * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Business Manager
 *
 * @param {postsBm3DotsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} language_id - the post_ stable id of the original post
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {string} tabName - Posts or Drafts
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - the language ML
 * @property {GUID} msid - msid
 * @property {string} action - view post, duplicate post, revert to draft, turn off commenting, move to trash, preview draft, duplicate draft
 * @return {LogObject<postsBm3DotsParams>} LogObject<postsBm3DotsParams>
 */
export function postsBm3Dots(params) {
    return { evid: 331, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'unpublishPost' event (evid: 332)
 *
 * Event description: When a post is unpublished.
 *
 * @param {unpublishPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {string} origin - post page, post editor
 * @property {string} translation_id - posts stable id of the original translated post
 * @property {GUID} msid - msid
 * @property {string} action - revert to draft, move trash
 * @return {LogObject<unpublishPostParams>} LogObject<unpublishPostParams>
 */
export function unpublishPost(params) {
    return { evid: 332, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postSoftDelete' event (evid: 333)
 *
 * Event description: When a post is moved to trash
 *
 * @param {postSoftDeleteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} language_id - the post stable if of the translated post
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {string} origin - post page, post editor, drafts
 * @property {GUID} msid - msid
 * @return {LogObject<postSoftDeleteParams>} LogObject<postSoftDeleteParams>
 */
export function postSoftDelete(params) {
    return { evid: 333, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'bm3DotsClick' event (evid: 334)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu, on the post list within the Business Manager (BM)
 *
 * @param {bm3DotsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} source - post BO section name: published, overview
 * @property {string} role - role
 * @property {string} tabName - tab name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<bm3DotsClickParams>} LogObject<bm3DotsClickParams>
 */
export function bm3DotsClick(params) {
    return { evid: 334, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'emailMarketingSelectPost' event (evid: 335)
 *
 * Event description: Whenever the user selects a post from the Email marketing post selection modal.
 *
 * @param {emailMarketingSelectPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<emailMarketingSelectPostParams>} LogObject<emailMarketingSelectPostParams>
 */
export function emailMarketingSelectPost(params) {
    return { evid: 335, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postScheduled' event (evid: 336)
 *
 * Event description: triggered when a post is scheduled.
 *
 * @param {postScheduledParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} role - member role (owner, writer, member)
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {number} giphy_count - count of used  giphy gifs
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {number} offset - the user timezone offset relative to UTC (in minutes)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {number} character_count - The number of characters on the post
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {DateTime} scheduled_date - The date when the post must be published (UTC)
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {string} member_id - NOT USED: member_id
 * @property {boolean} is_rescheduled - TRUE if rescheduled
 * @property {number} video_count - video_count in the post
 * @property {GUID} msid - msid
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @return {LogObject<postScheduledParams>} LogObject<postScheduledParams>
 */
export function postScheduled(params) {
    return { evid: 336, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postUnscheduled' event (evid: 337)
 *
 * Event description: When the user unschedules a post
 *
 * @param {postUnscheduledParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<postUnscheduledParams>} LogObject<postUnscheduledParams>
 */
export function postUnscheduled(params) {
    return { evid: 337, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'errorEvent' event (evid: 338)
 *
 * Event description: whenever the user sees an error message in post editor. Not sent if internet is gone for user, but user sees modal
 *
 * @param {errorEventParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} request_id - request_id (optional)
 * @property {string} applicationCode - applicationCode
 * @property {GUID} msid - msid
 * @property {string} action - which action triggered the error ( e.g. scheduling a post, publishing a post etc)
 * @return {LogObject<errorEventParams>} LogObject<errorEventParams>
 */
export function errorEvent(params) {
    return { evid: 338, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'dotsClickPostEditor' event (evid: 339)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu that sits next to the publish button, within the Post Editor
 *
 * @param {dotsClickPostEditorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {boolean} is_published - Is post published
 * @return {LogObject<dotsClickPostEditorParams>} LogObject<dotsClickPostEditorParams>
 */
export function dotsClickPostEditor(params) {
    return { evid: 339, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'dotsPostEditorOptionClicked' event (evid: 340)
 *
 * Event description: Whenever a user clicks one of the options from the 3 dots menu, in the Post Editor
 *
 * @param {dotsPostEditorOptionClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - is_edited
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post. stable id
 * @property {string} language - Language
 * @property {boolean} title_ok - is title set
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {string} action - Preview Post, Post Settings, Choose Category, Save as Draft, Schedule Post
 * @property {boolean} is_published - Is post published
 * @return {LogObject<dotsPostEditorOptionClickedParams>} LogObject<dotsPostEditorOptionClickedParams>
 */
export function dotsPostEditorOptionClicked(params) {
    return { evid: 340, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'bm3DotsClick341' event (evid: 341)
 *
 * Event description: Triggered when the user clicks on the 3 dots menu
 *
 * @param {bm3DotsClick341Params} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} source - post BO section name: published, overview
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<bm3DotsClick341Params>} LogObject<bm3DotsClick341Params>
 */
export function bm3DotsClick341(params) {
    return { evid: 341, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postEditorHoverOnUpgrade' event (evid: 342)
 *
 * Event description: User hover on a button in post editor
 *
 * @param {postEditorHoverOnUpgradeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - is_edited
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {string} button_name - button name which was hovered on
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - Multilingual language
 * @property {boolean} title_ok - is title set
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - Is post published
 * @return {LogObject<postEditorHoverOnUpgradeParams>} LogObject<postEditorHoverOnUpgradeParams>
 */
export function postEditorHoverOnUpgrade(params) {
    return { evid: 342, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'searchInBlogBo' event (evid: 343)
 *
 * Event description: Search in Blog BO
 *
 * @param {searchInBlogBoParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} text - Text entered in a search
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Search origin
 * @property {number} num_tags_found - number of tags found in search (if used in tag manager)
 * @property {number} num_posts_found - Number of posts found in search
 * @property {GUID} msid - msid
 * @return {LogObject<searchInBlogBoParams>} LogObject<searchInBlogBoParams>
 */
export function searchInBlogBo(params) {
    return { evid: 343, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'actionChoseInBmMoreActionsMenu' event (evid: 344)
 *
 * Event description: Triggered when the user clicks action under more actions menu in blog BO. For click on More actions itself, see event 69:341
 *
 * @param {actionChoseInBmMoreActionsMenuParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} source - post BO section name: published, overview
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} actionName - Action name chose inside menu
 * @property {GUID} msid - msid
 * @return {LogObject<actionChoseInBmMoreActionsMenuParams>} LogObject<actionChoseInBmMoreActionsMenuParams>
 */
export function actionChoseInBmMoreActionsMenu(params) {
    return { evid: 344, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postSettingsChangesSidebar' event (evid: 345)
 *
 * Event description: This event tracks all post settings changes made by the user. For each property changed one event is emitted.
 *
 * @param {postSettingsChangesSidebarParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of user - writer or admin
 * @property {string} post_id - post_id
 * @property {string} tab_name - SEO, Settings, Categories
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - the post language
 * @property {string} property_value - The value of the changed property
 * @property {string} translation_id - translation id
 * @property {string} property - The changed property (excerpt, author etc..)
 * @property {GUID} msid - msid
 * @property {boolean} is_published - Is post published (1-published)
 * @return {LogObject<postSettingsChangesSidebarParams>} LogObject<postSettingsChangesSidebarParams>
 */
export function postSettingsChangesSidebar(params) {
    return { evid: 345, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'bulkActionsOptionChosen' event (evid: 346)
 *
 * Event description: User did bulk action in Blog BO
 *
 * @param {bulkActionsOptionChosenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tabName - Posts or Drafts
 * @property {number} postsCount - Number of posts selected
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - Restore, Delete, Add Category
 * @return {LogObject<bulkActionsOptionChosenParams>} LogObject<bulkActionsOptionChosenParams>
 */
export function bulkActionsOptionChosen(params) {
    return { evid: 346, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'modalShown' event (evid: 347)
 *
 * Event description: Modal shown - generic event for many different modals.
 *
 * --Draft refresh:
 * Modal to refresh draft shown (there exists another version of the draft in another tab or Wix app)
 *
 * @param {modalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} additional_info - json with additional info
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<modalShownParams>} LogObject<modalShownParams>
 */
export function modalShown(params) {
    return { evid: 347, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'modalAction' event (evid: 348)
 *
 * Event description: Action on Modal - generic event for many different modals.
 *
 * --Draft refresh:
 * Action on modal to refresh draft (there exists another version of the draft in another tab or Wix app)
 *
 * @param {modalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} default_language - default language
 * @property {string} role - role
 * @property {string} language_selected - In multilingual context stores the language that the user chose
 * @property {string} additional_info - json with additional_info
 * @property {string} modal_name - modal name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} dataJson - if the modal has selections for the user those selections will be stored here
 * @property {string} origin - origin
 * @property {string} available_languages - an array with the available languages
 * @property {GUID} msid - msid
 * @property {string} action - Action on modal (for Draft refresh - close/save this version/discard this version)
 * @return {LogObject<modalActionParams>} LogObject<modalActionParams>
 */
export function modalAction(params) {
    return { evid: 348, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'editorSettingsPostPageBlogFeedShortcuts' event (evid: 349)
 *
 * Event description: user clicks on Post Page tab inside the blog feed settings
 *
 * @param {editorSettingsPostPageBlogFeedShortcutsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tab_name - tab name inside post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - blog feed settings / post feed settings
 * @property {string} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsPostPageBlogFeedShortcutsParams>} LogObject<editorSettingsPostPageBlogFeedShortcutsParams>
 */
export function editorSettingsPostPageBlogFeedShortcuts(params) {
    return { evid: 349, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postPagePostPageOpened' event (evid: 350)
 *
 * Event description: Post page opened in editor
 *
 * @param {postPagePostPageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - blog_feed, page_preview
 * @property {string} app_id - app_id
 * @property {string} referrer - The place from which this was opened
 * @property {GUID} msid - msid
 * @return {LogObject<postPagePostPageOpenedParams>} LogObject<postPagePostPageOpenedParams>
 */
export function postPagePostPageOpened(params) {
    return { evid: 350, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'editorSettingsOpened' event (evid: 351)
 *
 * Event description: Settings opened
 *
 * @param {editorSettingsOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - Desktop , Mobile. NOTE: Any Null values are desktop
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post_page, blog_feed
 * @property {string} app_id - app_id
 * @property {string} referrer - from which place it was opened
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsOpenedParams>} LogObject<editorSettingsOpenedParams>
 */
export function editorSettingsOpened(params) {
    return { evid: 351, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'editorSettingsTabOpened' event (evid: 352)
 *
 * Event description: Tab inside settings opened
 *
 * @param {editorSettingsTabOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {string} tab_name - tab name inside post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Place settings was changed in: blog_feed, post_page
 * @property {string} app_id - app_id
 * @property {string} referrer - from which place it was opened
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsTabOpenedParams>} LogObject<editorSettingsTabOpenedParams>
 */
export function editorSettingsTabOpened(params) {
    return { evid: 352, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postPagePostPageSettingsDisplayTab' event (evid: 353)
 *
 * Event description: Tab inside post page opened
 *
 * @param {postPagePostPageSettingsDisplayTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {boolean} toggle - toggle, 1 if checked, 0 if unchecked
 * @property {string} section - setting name, i.e. author name and picture, date and reading time, login from blog menu,  etc.
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} property_value - the value of the property
 * @property {string} app_id - app_id
 * @property {string} property - the property that was changed
 * @property {GUID} msid - msid
 * @return {LogObject<postPagePostPageSettingsDisplayTabParams>} LogObject<postPagePostPageSettingsDisplayTabParams>
 */
export function postPagePostPageSettingsDisplayTab(params) {
    return { evid: 353, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'editorSettingsDesignTab' event (evid: 356)
 *
 * Event description: Actions on tab inside settings
 *
 * @param {editorSettingsDesignTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {boolean} toggle - Deprecate
 * @property {string} section - The section where the changes occurred, i.e. Blog Menu, Posts, Buttons
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} property_value - the setting value. eg. True,
 * @property {string} app_id - app_id
 * @property {string} property - The property changed e.g. playback speed,
 * @property {GUID} msid - msid
 * @return {LogObject<editorSettingsDesignTabParams>} LogObject<editorSettingsDesignTabParams>
 */
export function editorSettingsDesignTab(params) {
    return { evid: 356, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'editorSettingsLayoutTab' event (evid: 357)
 *
 * Event description: Layout settings changed in editor. For custom feed all settings are returned in value field, for blog app it's spread to value, value_pagination_type, value_pagination_size. Use "settings" field to distinguish what was changed, origin - to identify blog app (main feed) and custom feed
 *
 * @param {editorSettingsLayoutTabParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} view_mode - desktop, mobile. NOTE: any Null values belong to desktop
 * @property {string} role - role
 * @property {string} tab_name - All poss feed/Category Page
 * @property {string} widget_name - Feed, Custom Feed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} editor_layout - Computer/Mobile
 * @property {string} origin - Post Page Settings, app settings (feed)
 * @property {string} app_id - app_id
 * @property {number} value_pagination_size - number of posts per page/per load
 * @property {string} value_pagination_type - With page numbers, on scroll....
 * @property {GUID} msid - msid
 * @property {string} value - setting chosen, i.e. Tiled (for layout), On scroll down (for post load), 7 (for posts per page)
 * @property {string} settings - setting name, i.e. layout, post load, posts per page
 * @return {LogObject<editorSettingsLayoutTabParams>} LogObject<editorSettingsLayoutTabParams>
 */
export function editorSettingsLayoutTab(params) {
    return { evid: 357, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogWidgetElementRemoved' event (evid: 358)
 *
 * Event description: Triggered when the user clicks on a CTA that requires selecting multiple posts.
 *
 * @param {blogWidgetElementRemovedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {GUID} msid - msid
 * @return {LogObject<blogWidgetElementRemovedParams>} LogObject<blogWidgetElementRemovedParams>
 */
export function blogWidgetElementRemoved(params) {
    return { evid: 358, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postSelectorAction' event (evid: 359)
 *
 * Event description: triggered when the user closes the post selector. Stores the
 *
 * @param {postSelectorActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {string} post_ids - array of post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} action - The button that the user clicked, Cancel, Done, 'X'
 * @return {LogObject<postSelectorActionParams>} LogObject<postSelectorActionParams>
 */
export function postSelectorAction(params) {
    return { evid: 359, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogSettingsOpenedInBm' event (evid: 360)
 *
 * Event description: Blog settings opened (in BM)
 *
 * @param {blogSettingsOpenedInBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - BM_posts
 * @property {string} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<blogSettingsOpenedInBmParams>} LogObject<blogSettingsOpenedInBmParams>
 */
export function blogSettingsOpenedInBm(params) {
    return { evid: 360, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogSettingsSavedInBm' event (evid: 361)
 *
 * Event description: Blog settings saved (in BM)
 *
 * @param {blogSettingsSavedInBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} schema_enabled - 1 - enabled, 0 - didn't
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {number} amp_changed - 1 - changed, 0 - didn't
 * @property {number} emailmembers_changed - 1 - changed, 0 - didn't
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {number} emailsubscribers_changed - 1 - changed, 0 - didn't
 * @property {number} emailmembers_enabled - 1 - enabled, 0 - didn't
 * @property {string} origin - BM_posts
 * @property {number} logo_changed - 1 - added/changed, 0 - didn't
 * @property {number} amp_enabled - 1 - enabled, 0 - didn't
 * @property {string} app_id - app_id
 * @property {number} schema_changed - 1 - changed, 0 - didn't
 * @property {number} emailsubscribers_enabled - 1 - enabled, 0 - didn't
 * @property {GUID} msid - msid
 * @property {string} settings - json string with values 0 - disabled, 1 - enabled, e.g. {AMP: 1, Schema: 0, logo : 0 }
 * @return {LogObject<blogSettingsSavedInBmParams>} LogObject<blogSettingsSavedInBmParams>
 */
export function blogSettingsSavedInBm(params) {
    return { evid: 361, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'imageSettingsPanelInPostEditorOpened' event (evid: 362)
 *
 * Event description: image settings panel in post editor opened
 *
 * @param {imageSettingsPanelInPostEditorOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {string} member_id - member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<imageSettingsPanelInPostEditorOpenedParams>} LogObject<imageSettingsPanelInPostEditorOpenedParams>
 */
export function imageSettingsPanelInPostEditorOpened(params) {
    return { evid: 362, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'helperShowed' event (evid: 363)
 *
 * Event description: Helper was showed (for custom feed confusion currently, can be reused later for others if needed)
 *
 * @param {helperShowedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - name of helper
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<helperShowedParams>} LogObject<helperShowedParams>
 */
export function helperShowed(params) {
    return { evid: 363, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'helperAction' event (evid: 364)
 *
 * Event description: Action on helper_showed (for custom feed confusion currently, can be reused later for others if needed) - close or learn more
 *
 * @param {helperActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - name of helper
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} action - action in helper (close, learn more)
 * @return {LogObject<helperActionParams>} LogObject<helperActionParams>
 */
export function helperAction(params) {
    return { evid: 364, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'authorOfflineCreated' event (evid: 365)
 *
 * Event description: Created an offline author
 *
 * @param {authorOfflineCreatedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} has_picture - TRUE if a picture is assigned for created author
 * @property {string} author_name - Author name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} author_title - author title
 * @property {string} author_role - Currently "Offline", might be reused later
 * @property {GUID} author_id - Author id which was created
 * @property {GUID} msid - msid
 * @return {LogObject<authorOfflineCreatedParams>} LogObject<authorOfflineCreatedParams>
 */
export function authorOfflineCreated(params) {
    return { evid: 365, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'authorEdited' event (evid: 366)
 *
 * Event description: Author edited.
 *
 * @param {authorEditedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} new_author_name - new name after edit
 * @property {boolean} has_picture - TRUE if author already has a picture (nice to have)
 * @property {boolean} has_cover - does have a cover image
 * @property {boolean} was_picture_changed - if picture was changed on editing author
 * @property {boolean} cover_changed - cover has changed
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} new_author_title - new title after edit
 * @property {string} origin - origin
 * @property {string} author_role - Currently just "Offline/Owner" - might be reused later
 * @property {GUID} author_id - Author id = site member id
 * @property {boolean} was_name_changed - was_name_changed
 * @property {GUID} msid - msid
 * @return {LogObject<authorEditedParams>} LogObject<authorEditedParams>
 */
export function authorEdited(params) {
    return { evid: 366, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'authorOfflineDeleted' event (evid: 367)
 *
 * Event description: Deleted an offline author
 *
 * @param {authorOfflineDeletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {boolean} has_picture - TRUE if a picture is assigned for created author (nice to have)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} author_role - Currently "Offline", might be reused later
 * @property {GUID} author_id - Author id which was created
 * @property {GUID} msid - msid
 * @return {LogObject<authorOfflineDeletedParams>} LogObject<authorOfflineDeletedParams>
 */
export function authorOfflineDeleted(params) {
    return { evid: 367, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogSettingsEditSeoBlogPostsClick' event (evid: 368)
 *
 * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section.
 *
 * @param {blogSettingsEditSeoBlogPostsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - which cta the user clicked: Posts, Categories or Tags
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<blogSettingsEditSeoBlogPostsClickParams>} LogObject<blogSettingsEditSeoBlogPostsClickParams>
 */
export function blogSettingsEditSeoBlogPostsClick(params) {
    return { evid: 368, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogSettingsEditSeoBlogCategoriesClick' event (evid: 369)
 *
 * Event description: triggered when the user clicks on the edit button on the Blog settings screen, under the SEO settings section.
 *
 * @param {blogSettingsEditSeoBlogCategoriesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<blogSettingsEditSeoBlogCategoriesClickParams>} LogObject<blogSettingsEditSeoBlogCategoriesClickParams>
 */
export function blogSettingsEditSeoBlogCategoriesClick(params) {
    return { evid: 369, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'errorMessageShow' event (evid: 372)
 *
 * Event description: whenever an error message is shown (tooltip, modal)
 *
 * @param {errorMessageShowParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} error_type - Error type
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} error_message - error message
 * @property {string} type - The way it was displayed: Tooltip, Modal, toast etc..
 * @property {GUID} msid - msid
 * @property {number} error_code - http code
 * @return {LogObject<errorMessageShowParams>} LogObject<errorMessageShowParams>
 */
export function errorMessageShow(params) {
    return { evid: 372, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'errorMessageShowCtaClick' event (evid: 373)
 *
 * Event description: whenever an error msg cta is clicked (customer care, cancel etc..)
 *
 * @param {errorMessageShowCtaClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} error_type - error type
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {string} error_message - error message
 * @property {string} type - The way it was displayed: Tooltip, Modal, toast etc..
 * @property {GUID} msid - msid
 * @property {number} error_code - http error code
 * @property {string} action - the cta clicked - customer care, cancel ... others
 * @return {LogObject<errorMessageShowCtaClickParams>} LogObject<errorMessageShowCtaClickParams>
 */
export function errorMessageShowCtaClick(params) {
    return { evid: 373, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogFeedRenamed' event (evid: 374)
 *
 * Event description: When the user renames the Main blog feed from the BM
 *
 * @param {blogFeedRenamedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} name - The new feed name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} old_name - The updated value
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} msid - msid
 * @return {LogObject<blogFeedRenamedParams>} LogObject<blogFeedRenamedParams>
 */
export function blogFeedRenamed(params) {
    return { evid: 374, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'newCategoryClick' event (evid: 375)
 *
 * Event description: triggered when click on "new category" CTA
 *
 * @param {newCategoryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<newCategoryClickParams>} LogObject<newCategoryClickParams>
 */
export function newCategoryClick(params) {
    return { evid: 375, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'categoryDeleted' event (evid: 376)
 *
 * Event description: When a category is deleted
 *
 * @param {categoryDeletedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - category language
 * @property {string} origin - post page, post editor, drafts
 * @property {string} category_id - category id
 * @property {string} translation_id - the id of the translated category
 * @property {GUID} msid - msid
 * @return {LogObject<categoryDeletedParams>} LogObject<categoryDeletedParams>
 */
export function categoryDeleted(params) {
    return { evid: 376, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'paidPostInsidePostEditorSidebar' event (evid: 377)
 *
 * Event description: Option chosen inside Paid Post in post editor sidebar
 *
 * @param {paidPostInsidePostEditorSidebarParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} option - Get Started/Learn More
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @return {LogObject<paidPostInsidePostEditorSidebarParams>} LogObject<paidPostInsidePostEditorSidebarParams>
 */
export function paidPostInsidePostEditorSidebar(params) {
    return { evid: 377, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postEditorAddMediaElementClick' event (evid: 378)
 *
 * Event description: When the user clicks the "+" in the post editor (sidebar or text area)
 *
 * @param {postEditorAddMediaElementClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} tab_name - Which tab was opened in post settings
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - sidebar or text area
 * @property {GUID} msid - msid
 * @return {LogObject<postEditorAddMediaElementClickParams>} LogObject<postEditorAddMediaElementClickParams>
 */
export function postEditorAddMediaElementClick(params) {
    return { evid: 378, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postEditorAddRemoveMediaElement' event (evid: 379)
 *
 * Event description: When the user clicks the "+" in the post editor (sidebar or text area)
 *
 * @param {postEditorAddRemoveMediaElementParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - Role of the user - writer or admin
 * @property {string} tab_name - image, video, gallery, gif, html code (maybe not necessary)
 * @property {string} adding_method - Click or drag n drop
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - sidebar or composer
 * @property {string} mediaOrigin - upload, embed, giphy  etc..
 * @property {string} media_content - the added media content if applicable (links, file name, html code)
 * @property {string} media_type - image, video etc..
 * @property {GUID} msid - msid
 * @property {string} action_type - Add or Remove
 * @return {LogObject<postEditorAddRemoveMediaElementParams>} LogObject<postEditorAddRemoveMediaElementParams>
 */
export function postEditorAddRemoveMediaElement(params) {
    return { evid: 379, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationHomePageOpened' event (evid: 380)
 *
 * Event description: triggered when Migration home page opened actually open
 *
 * @param {migrationHomePageOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @property {boolean} is_full_width - is_full_width (with left nav or not)
 * @return {LogObject<migrationHomePageOpenedParams>} LogObject<migrationHomePageOpenedParams>
 */
export function migrationHomePageOpened(params) {
    return { evid: 380, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationGetStartedClick' event (evid: 381)
 *
 * Event description: triggered when users click on get started
 *
 * @param {migrationGetStartedClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationGetStartedClickParams>} LogObject<migrationGetStartedClickParams>
 */
export function migrationGetStartedClick(params) {
    return { evid: 381, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationMaybeLaterClick' event (evid: 382)
 *
 * Event description: triggered when users click on Maybe later click
 *
 * @param {migrationMaybeLaterClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationMaybeLaterClickParams>} LogObject<migrationMaybeLaterClickParams>
 */
export function migrationMaybeLaterClick(params) {
    return { evid: 382, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationLearnMoreClick' event (evid: 383)
 *
 * Event description: triggered when users click on Maybe Learn more click
 *
 * @param {migrationLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationLearnMoreClickParams>} LogObject<migrationLearnMoreClickParams>
 */
export function migrationLearnMoreClick(params) {
    return { evid: 383, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationImportPageFirstStepOpened' event (evid: 384)
 *
 * Event description: triggered when Migration Import page first step actually open
 *
 * @param {migrationImportPageFirstStepOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationImportPageFirstStepOpenedParams>} LogObject<migrationImportPageFirstStepOpenedParams>
 */
export function migrationImportPageFirstStepOpened(params) {
    return { evid: 384, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationCopyPostsClick' event (evid: 385)
 *
 * Event description: triggered when users click on Copy posts
 *
 * @param {migrationCopyPostsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationCopyPostsClickParams>} LogObject<migrationCopyPostsClickParams>
 */
export function migrationCopyPostsClick(params) {
    return { evid: 385, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationCopiedSuccessModalOpened' event (evid: 386)
 *
 * Event description: triggered when Migration Copied success modal opened actually open
 *
 * @param {migrationCopiedSuccessModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationCopiedSuccessModalOpenedParams>} LogObject<migrationCopiedSuccessModalOpenedParams>
 */
export function migrationCopiedSuccessModalOpened(params) {
    return { evid: 386, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationKeepGoingClick' event (evid: 387)
 *
 * Event description: triggered when users click on Keep going click
 *
 * @param {migrationKeepGoingClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationKeepGoingClickParams>} LogObject<migrationKeepGoingClickParams>
 */
export function migrationKeepGoingClick(params) {
    return { evid: 387, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationCloseModalClick' event (evid: 388)
 *
 * Event description: triggered when users click on Keep going click
 *
 * @param {migrationCloseModalClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} modal_name - post transferred, success
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationCloseModalClickParams>} LogObject<migrationCloseModalClickParams>
 */
export function migrationCloseModalClick(params) {
    return { evid: 388, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationImportPageSecondStepOpened' event (evid: 389)
 *
 * Event description: triggered when Migration Import page second step actually open
 *
 * @param {migrationImportPageSecondStepOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationImportPageSecondStepOpenedParams>} LogObject<migrationImportPageSecondStepOpenedParams>
 */
export function migrationImportPageSecondStepOpened(params) {
    return { evid: 389, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationUpdateAndPublishClick' event (evid: 390)
 *
 * Event description: triggered when users click on Update and publish click
 *
 * @param {migrationUpdateAndPublishClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateAndPublishClickParams>} LogObject<migrationUpdateAndPublishClickParams>
 */
export function migrationUpdateAndPublishClick(params) {
    return { evid: 390, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationUpdateUrlsModalOpened' event (evid: 391)
 *
 * Event description: triggered when Migration Update URLs modal actually open
 *
 * @param {migrationUpdateUrlsModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateUrlsModalOpenedParams>} LogObject<migrationUpdateUrlsModalOpenedParams>
 */
export function migrationUpdateUrlsModalOpened(params) {
    return { evid: 391, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationUpdateAndPublishConfirmationClick' event (evid: 392)
 *
 * Event description: triggered when users click on Update and publish confirmation click
 *
 * @param {migrationUpdateAndPublishConfirmationClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateAndPublishConfirmationClickParams>} LogObject<migrationUpdateAndPublishConfirmationClickParams>
 */
export function migrationUpdateAndPublishConfirmationClick(params) {
    return { evid: 392, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationUpdateSuccessModalOpened' event (evid: 393)
 *
 * Event description: triggered when Migration Update URLs modal actually open
 *
 * @param {migrationUpdateSuccessModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationUpdateSuccessModalOpenedParams>} LogObject<migrationUpdateSuccessModalOpenedParams>
 */
export function migrationUpdateSuccessModalOpened(params) {
    return { evid: 393, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationDoneClick' event (evid: 394)
 *
 * Event description: triggered when users click on done click
 *
 * @param {migrationDoneClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationDoneClickParams>} LogObject<migrationDoneClickParams>
 */
export function migrationDoneClick(params) {
    return { evid: 394, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationGiveFeedbackClick' event (evid: 395)
 *
 * Event description: triggered when users click on Give feedback
 *
 * @param {migrationGiveFeedbackClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationGiveFeedbackClickParams>} LogObject<migrationGiveFeedbackClickParams>
 */
export function migrationGiveFeedbackClick(params) {
    return { evid: 395, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationMigrationFailed' event (evid: 396)
 *
 * Event description: triggered when Migration fails
 *
 * @param {migrationMigrationFailedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} referral_info - referral_info
 * @property {boolean} is_first - is it the first time the user opens this tab?
 * @property {string} migration_status - First time, In progress, Done, Failed (after finishing migration)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} msid - msid
 * @return {LogObject<migrationMigrationFailedParams>} LogObject<migrationMigrationFailedParams>
 */
export function migrationMigrationFailed(params) {
    return { evid: 396, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationQuickMigrationAd' event (evid: 397)
 *
 * Event description: Whenever the user clicks one option from the switch to new blog ad. The ad appears within the editor, on the new and old blog 6th button and on the old blog manager.
 *
 * @param {migrationQuickMigrationAdParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} post_id - post id
 * @property {boolean} do_not_show_again - do not show again flag
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - new blog 6th button, old blog 6th button, old blog manager, add panel
 * @property {GUID} msid - msid
 * @property {string} action - switch, find out more, later, close
 * @return {LogObject<migrationQuickMigrationAdParams>} LogObject<migrationQuickMigrationAdParams>
 */
export function migrationQuickMigrationAd(params) {
    return { evid: 397, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationLearnHowToSwitchDeleteOldBlog' event (evid: 398)
 *
 * Event description: Whenever the user clicks on the learn how link from the old blog 6th button - learn how to delete, learn how to switch
 *
 * @param {migrationLearnHowToSwitchDeleteOldBlogParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - old blog 6th button
 * @property {GUID} msid - msid
 * @property {string} action - switch, delete
 * @return {LogObject<migrationLearnHowToSwitchDeleteOldBlogParams>} LogObject<migrationLearnHowToSwitchDeleteOldBlogParams>
 */
export function migrationLearnHowToSwitchDeleteOldBlog(params) {
    return { evid: 398, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'blogLoadedInEditor' event (evid: 399)
 *
 * Event description: Once blog app loaded in Editor, used for AB test exposure. NOTE: When the Page post is selected and whenever the user switches the view, the event gets triggered 2 times one with Blog feed and another with Post view.
 *
 * @param {blogLoadedInEditorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} editor_view_mode - Computer/Mobile
 * @property {GUID} post_stable_id - post_stable_id
 * @property {GUID} msid - msid
 * @property {string} blog_view - Blog Feed or Post Page
 * @property {boolean} isPreview - Is it in Preview mode (if not, it's Editor)
 * @return {LogObject<blogLoadedInEditorParams>} LogObject<blogLoadedInEditorParams>
 */
export function blogLoadedInEditor(params) {
    return { evid: 399, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'migrationPostCopyingStatus' event (evid: 401)
 *
 * Event description: Triggered when the migration completes both successfully or failed.
 *
 * @param {migrationPostCopyingStatusParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} migration_succeed - 1 - yes / 0 - no
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} visitor_id - visitor_id
 * @property {number} num_posts_total - the number of total posts to copy
 * @property {number} num_posts_unsucc - the number of posts that weren't copied
 * @property {GUID} post_stable_id - post_stable_id
 * @property {boolean} was_post_too_big - was_post_too_big
 * @property {string} error_message - error message if unsuscessfull
 * @property {string} posts_with_too_large_content
 * @property {GUID} msid - msid
 * @property {number} too_large_post_count - too_large_post_count
 * @return {LogObject<migrationPostCopyingStatusParams>} LogObject<migrationPostCopyingStatusParams>
 */
export function migrationPostCopyingStatus(params) {
    return { evid: 401, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'appInstallAutopilot' event (evid: 402)
 *
 * Event description: sends if app was installed, used for autopilot for post page migration
 *
 * @param {appInstallAutopilotParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} uuid - uuid
 * @property {string} __cookies_prefix__uuid - __cookies_prefix__uuid
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} app_id - installed app id
 * @property {GUID} msid - msid
 * @return {LogObject<appInstallAutopilotParams>} LogObject<appInstallAutopilotParams>
 */
export function appInstallAutopilot(params) {
    return { evid: 402, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'updateBlogModalShown' event (evid: 405)
 *
 * Event description: Whenver the user sees the migration option - Migration message shown
 *
 * @param {updateBlogModalShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {boolean} new_blog_valid - TRUE if new Blog is installed (nice to have)
 * @property {string} screen_name - screen_name
 * @property {string} modal_name - "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin - 6th button or right after opening Editor or some other place
 * @property {GUID} msid - msid
 * @return {LogObject<updateBlogModalShownParams>} LogObject<updateBlogModalShownParams>
 */
export function updateBlogModalShown(params) {
    return { evid: 405, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'updateBlogModalAction' event (evid: 406)
 *
 * Event description: Action on migration message (shown - evid 405)
 *
 * @param {updateBlogModalActionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {boolean} new_blog_valid - if the site has new blog installed
 * @property {string} screen_name - screen_name
 * @property {string} modal_name - "Upgrade to the new blog".; "Magic Migration Blog Out of date"; "Magic Migration Blog Out of date - update options"
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin (nice to have if we get any)
 * @property {string} choice - Content update/Content and design update
 * @property {string} choise - Content update/Content and design update - if user has both blogs (NOT USED)
 * @property {GUID} msid - msid
 * @property {string} action - action - close, learn more, update now
 * @return {LogObject<updateBlogModalActionParams>} LogObject<updateBlogModalActionParams>
 */
export function updateBlogModalAction(params) {
    return { evid: 406, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'magicMigrationStart' event (evid: 409)
 *
 * Event description: Magic Migration Failed after copied posts, error message
 *
 * @param {magicMigrationStartParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} error_message - error_message
 * @property {string} migration_step - migration step error occuried
 * @property {GUID} msid - msid
 * @return {LogObject<magicMigrationStartParams>} LogObject<magicMigrationStartParams>
 */
export function magicMigrationStart(params) {
    return { evid: 409, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'hoverOnTooltip' event (evid: 413)
 *
 * Event description: Fired when the user hovers a tooltip
 *
 * @param {hoverOnTooltipParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} tooltip_name - tooltip name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} text - the tooltip text
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<hoverOnTooltipParams>} LogObject<hoverOnTooltipParams>
 */
export function hoverOnTooltip(params) {
    return { evid: 413, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualLanguagePickerOpen' event (evid: 415)
 *
 * Event description: Triggered when the user clicks and opens on the language picker
 *
 * @param {multilingualLanguagePickerOpenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - instance id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} tabName - tab name
 * @property {boolean} isFilter - is the language picker a filter?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - instance id
 * @return {LogObject<multilingualLanguagePickerOpenParams>} LogObject<multilingualLanguagePickerOpenParams>
 */
export function multilingualLanguagePickerOpen(params) {
    return { evid: 415, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualLanguagePickerLanguageClick' event (evid: 416)
 *
 * Event description: Triggered when the user chooses a language from the language picker
 *
 * @param {multilingualLanguagePickerLanguageClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - instance id
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} language_selected - language selected
 * @property {string} tabName - tab name
 * @property {boolean} isFilter - is the language picker a filter?
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} msid - instance id
 * @return {LogObject<multilingualLanguagePickerLanguageClickParams>} LogObject<multilingualLanguagePickerLanguageClickParams>
 */
export function multilingualLanguagePickerLanguageClick(params) {
    return { evid: 416, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualCategoryTranslateClick' event (evid: 417)
 *
 * Event description: triggered when click on translate CTA
 *
 * @param {multilingualCategoryTranslateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {string} category_id - category id
 * @property {string} translation_id - the category id of the translated post
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualCategoryTranslateClickParams>} LogObject<multilingualCategoryTranslateClickParams>
 */
export function multilingualCategoryTranslateClick(params) {
    return { evid: 417, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'multilingualHoverTranslateGlobe' event (evid: 418)
 *
 * Event description: triggered when user hovers on the translate globe.
 *
 * @param {multilingualHoverTranslateGlobeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} tabName - tab name: published, drafts, trash,  categories
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} community_id - community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<multilingualHoverTranslateGlobeParams>} LogObject<multilingualHoverTranslateGlobeParams>
 */
export function multilingualHoverTranslateGlobe(params) {
    return { evid: 418, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'editorCustomizeLayoutButtonClick' event (evid: 420)
 *
 * Event description: User clicked customize layout from the while editing the blog or post feed
 *
 * @param {editorCustomizeLayoutButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post list, blog feed
 * @property {string} layout - the selected layout
 * @property {GUID} msid - msid
 * @return {LogObject<editorCustomizeLayoutButtonClickParams>} LogObject<editorCustomizeLayoutButtonClickParams>
 */
export function editorCustomizeLayoutButtonClick(params) {
    return { evid: 420, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'wixPostImporterImportStarted' event (evid: 421)
 *
 * Event description: Wix post importer: Import Started.
 *
 * @param {wixPostImporterImportStartedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - the instance_id from which the posts were imported
 * @property {GUID} original_msid - the msid from which the posts were imported
 * @property {GUID} msid - msid
 * @return {LogObject<wixPostImporterImportStartedParams>} LogObject<wixPostImporterImportStartedParams>
 */
export function wixPostImporterImportStarted(params) {
    return { evid: 421, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'wixPostImporterImportFinished' event (evid: 422)
 *
 * Event description: Triggered when the import wix posts process starts
 *
 * @param {wixPostImporterImportFinishedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} fail_reason - if the import failed what was the reason
 * @property {number} num_posts_total - the number of posts to be imported
 * @property {number} num_posts_unsucc - number of posts that failed to import
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - origin
 * @property {GUID} original_instance_id - the instance_id from which the posts were imported
 * @property {GUID} original_msid - the msid from which the posts were imported
 * @property {boolean} is_successful - was the import successful
 * @property {GUID} msid - msid
 * @return {LogObject<wixPostImporterImportFinishedParams>} LogObject<wixPostImporterImportFinishedParams>
 */
export function wixPostImporterImportFinished(params) {
    return { evid: 422, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postTemplatesWriteNewPostFromTemplateClick' event (evid: 423)
 *
 * Event description: triggered when click on write new post from template
 *
 * @param {postTemplatesWriteNewPostFromTemplateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postTemplatesWriteNewPostFromTemplateClickParams>} LogObject<postTemplatesWriteNewPostFromTemplateClickParams>
 */
export function postTemplatesWriteNewPostFromTemplateClick(params) {
    return { evid: 423, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postTemplatesSelectTemplateFromListClick' event (evid: 424)
 *
 * Event description: triggered when click on a template from the list
 *
 * @param {postTemplatesSelectTemplateFromListClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} template_name - template name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} templateCategory - template category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {string} template_id - the template id clicked
 * @return {LogObject<postTemplatesSelectTemplateFromListClickParams>} LogObject<postTemplatesSelectTemplateFromListClickParams>
 */
export function postTemplatesSelectTemplateFromListClick(params) {
    return { evid: 424, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postTemplatesFilterTemplateByCategory' event (evid: 425)
 *
 * Event description: triggered when click on a template category from the drop down list
 *
 * @param {postTemplatesFilterTemplateByCategoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} templateCategory - template category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postTemplatesFilterTemplateByCategoryParams>} LogObject<postTemplatesFilterTemplateByCategoryParams>
 */
export function postTemplatesFilterTemplateByCategory(params) {
    return { evid: 425, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postTemplatesUseThisTemplateClick' event (evid: 426)
 *
 * Event description: triggered when click on use this template CTA
 *
 * @param {postTemplatesUseThisTemplateClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} template_name - template name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} templateCategory - template category
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {string} template_id - template id
 * @return {LogObject<postTemplatesUseThisTemplateClickParams>} LogObject<postTemplatesUseThisTemplateClickParams>
 */
export function postTemplatesUseThisTemplateClick(params) {
    return { evid: 426, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postEditorHelpPanelClick' event (evid: 432)
 *
 * Event description: Whenever a user clicks on any link on the help panel.
 *
 * @param {postEditorHelpPanelClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} click_name - click name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post. stable id
 * @property {string} language - Language
 * @property {string} origin - origin
 * @property {string} translation_id - translation_id
 * @property {GUID} msid - msid
 * @return {LogObject<postEditorHelpPanelClickParams>} LogObject<postEditorHelpPanelClickParams>
 */
export function postEditorHelpPanelClick(params) {
    return { evid: 432, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postHistoryViewPostHistoryClick' event (evid: 433)
 *
 * Event description: triggered when click on view post history CTA
 *
 * @param {postHistoryViewPostHistoryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - for multilingual
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {boolean} is_offline - if the event happened offline
 * @property {string} translation_id - translation id
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryViewPostHistoryClickParams>} LogObject<postHistoryViewPostHistoryClickParams>
 */
export function postHistoryViewPostHistoryClick(params) {
    return { evid: 433, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postHistoryPostHistoryScreenShown' event (evid: 434)
 *
 * Event description: When the user sees the post history screen
 *
 * @param {postHistoryPostHistoryScreenShownParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - language
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {string} translation_id - translation id
 * @property {number} revision_count - the number of revisions displayed
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryPostHistoryScreenShownParams>} LogObject<postHistoryPostHistoryScreenShownParams>
 */
export function postHistoryPostHistoryScreenShown(params) {
    return { evid: 434, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postHistoryPostHistoryScreenClicks' event (evid: 435)
 *
 * Event description: Post history - post history screen clicks.
 *
 * @param {postHistoryPostHistoryScreenClicksParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - click_name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {string} revisionId - revision id
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - language
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {string} translation_id - translation id
 * @property {number} revision_count - the number of revisions displayed
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryPostHistoryScreenClicksParams>} LogObject<postHistoryPostHistoryScreenClicksParams>
 */
export function postHistoryPostHistoryScreenClicks(params) {
    return { evid: 435, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postHistoryRevisionRestoredSuccessfully' event (evid: 436)
 *
 * Event description: When the revision was successfully restored
 *
 * @param {postHistoryRevisionRestoredSuccessfullyParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id if applicable
 * @property {string} revisionId - post revision id
 * @property {string} original_revision_id - post original revision id
 * @property {GUID} post_stable_id - post stable id
 * @property {string} language - language
 * @property {string} origin - origin - examples: related_posts, paid_plans etc..
 * @property {string} translation_id - translation id
 * @property {GUID} msid - msid
 * @return {LogObject<postHistoryRevisionRestoredSuccessfullyParams>} LogObject<postHistoryRevisionRestoredSuccessfullyParams>
 */
export function postHistoryRevisionRestoredSuccessfully(params) {
    return { evid: 436, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'buisinessManagerClickThatDirectsOutOfBm' event (evid: 437)
 *
 * Event description: When the user clicks on a CTA within the BM, that leads to another page outside blog scope. eg. Editor, App market etc..
 *
 * @param {buisinessManagerClickThatDirectsOutOfBmParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {string} click_name - click name
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - Language
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @property {string} destination - where is the user being routed to, Editor, app market
 * @return {LogObject<buisinessManagerClickThatDirectsOutOfBmParams>} LogObject<buisinessManagerClickThatDirectsOutOfBmParams>
 */
export function buisinessManagerClickThatDirectsOutOfBm(params) {
    return { evid: 437, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postTemplatesSeeMoreTemplatesClick' event (evid: 438)
 *
 * Event description: triggered when click on write new post from template
 *
 * @param {postTemplatesSeeMoreTemplatesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} language - for multilingual
 * @property {string} origin - origin
 * @property {boolean} is_offline - if the event happened offline
 * @property {GUID} app_id - app_id (forum, blog, members)
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<postTemplatesSeeMoreTemplatesClickParams>} LogObject<postTemplatesSeeMoreTemplatesClickParams>
 */
export function postTemplatesSeeMoreTemplatesClick(params) {
    return { evid: 438, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'noteClick' event (evid: 439)
 *
 * Event description: BI event firing when clicking on Note in Post Editor
 *
 * @param {noteClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - can be : owner , writer, editor
 * @property {GUID} visitor_id - visitor ID
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} parent_resource_id - notes' parent entity GUID ( e.g. post, group, event, post etc)
 * @property {string} app_id - app_id
 * @property {GUID} site_member_id - member ID after logging to Wix site
 * @property {GUID} msid - msid
 * @return {LogObject<noteClickParams>} LogObject<noteClickParams>
 */
export function noteClick(params) {
    return { evid: 439, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'clickingOnPost' event (evid: 440)
 *
 * Event description: Sending an event when clicking on Post from Owner App, Comments section
 *
 * @param {clickingOnPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role
 * @property {string} post_id - The post that was clicked
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Where the post was clicked from ( in this case Comments)
 * @property {GUID} msid - msid
 * @return {LogObject<clickingOnPostParams>} LogObject<clickingOnPostParams>
 */
export function clickingOnPost(params) {
    return { evid: 440, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'clickOnLink' event (evid: 441)
 *
 * Event description: Click on Link.
 *
 * @param {clickOnLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} bi_token - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} tab_name - tab_name
 * @property {GUID} uuid - uuid
 * @property {string} origin_name - origin_name
 * @property {string} button_name - How the button is named
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - For example: ‘Blog’ , ‘RSS Widget’ , ‘Post Page’ , ‘Post List’ and so on
 * @property {GUID} msid - msid
 * @property {Url} button_link - the link of the button( particular support page)
 * @return {LogObject<clickOnLinkParams>} LogObject<clickOnLinkParams>
 */
export function clickOnLink(params) {
    return { evid: 441, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppSharePostButtonTypeClick' event (evid: 442)
 *
 * Event description: user clicked on share button type (sends sms, share social, copy link etc..) in oneapp
 *
 * @param {oneAppSharePostButtonTypeClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - biToken
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} button_name - sends via sms, share via social, copy invite link etc..
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page, view post etc.
 * @property {GUID} msid - biToken
 * @return {LogObject<oneAppSharePostButtonTypeClickParams>} LogObject<oneAppSharePostButtonTypeClickParams>
 */
export function oneAppSharePostButtonTypeClick(params) {
    return { evid: 442, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'oneAppScrollPositionInPostForReadingTime' event (evid: 444)
 *
 * Event description: triggered when view post type clicked: space by wix or mobile web
 *
 * @param {oneAppScrollPositionInPostForReadingTimeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - member role (owner, writer, member)
 * @property {string} post_id - post_id
 * @property {string} button_name - button name clicked under view post: space by wix or mobile web
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - language
 * @property {string} origin - which page the action took place in - view post, more actions..
 * @property {boolean} is_offline - if the action happened while offline
 * @property {string} translation_id - the original post stable_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {boolean} is_published - 0 - not published (draft) / 1 - published
 * @return {LogObject<oneAppScrollPositionInPostForReadingTimeParams>} LogObject<oneAppScrollPositionInPostForReadingTimeParams>
 */
export function oneAppScrollPositionInPostForReadingTime(params) {
    return { evid: 444, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postModerationButtonClick' event (evid: 446)
 *
 * Event description: When owner/guest_writer clicks one of the main buttons: review/edit/view_post in pending review tab.
 *
 * @param {postModerationButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} role - role
 * @property {string} post_id - post_id
 * @property {string} button_name - the button name
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - post page
 * @property {GUID} msid - msid
 * @return {LogObject<postModerationButtonClickParams>} LogObject<postModerationButtonClickParams>
 */
export function postModerationButtonClick(params) {
    return { evid: 446, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'postModerationStatus' event (evid: 447)
 *
 * Event description: Tracks post's status: sent_for_approval/approved/rejected_and_reverted/reverted/updated/deleted/translated/
 *
 * @param {postModerationStatusParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} image_count - image_count in the post
 * @property {boolean} is_demo - is_demo
 * @property {string} previous_post_status - previous_post_status
 * @property {string} screen_name - screen_name
 * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
 * @property {string} post_title - post_title
 * @property {string} role - DONT USE! member role (owner, writer, member) (use 'roles')
 * @property {string} url - url
 * @property {string} category_ids - category_ids. JSON array string
 * @property {string} post_id - post_id
 * @property {boolean} has_gallery - NOT IN USE: 0 - no gallery / 1 - published with gallery
 * @property {string} referral_info - NOT IN USE: external links - facebook, social networks. if from wix then null
 * @property {number} giphy_count - giphy_count
 * @property {string} tag_ids - tag_ids
 * @property {number} categories_count - categories_count
 * @property {boolean} used_html - 0 - didnt used html component / 1 - used html component
 * @property {GUID} post_stable_id - stable id
 * @property {string} language - for multilingual
 * @property {number} character_count - character_count
 * @property {string} original_post_id - the original post id
 * @property {string} community_id - NOT IN USE: community_id (instance of members app)
 * @property {string} origin - which page the action took place in - home_page, category_page, post_page, members_page, recent_posts, mega_menu, post_editor
 * @property {GUID} original_instance_id - Currently being used for wix reads posts.in the members app events. holds the child app (forum/blog) instance_id
 * @property {string} new_post_status - current post status: sent_for_approval/approved/rejected_and_reverted/reverted/updated/deleted/translated/
 * @property {string} translation_id - the post_stable_id of the post that was translated
 * @property {GUID} app_id - app_id
 * @property {GUID} author_id - author id
 * @property {string} paid_plan_id - paid_plan_id
 * @property {number} video_count - video_count
 * @property {GUID} msid - msid
 * @property {boolean} is_published - is_published
 * @property {string} galleries - will sent as array - [{ layout: 'masonry', count: 5}, { layout: 'whatever', count: 10 }]
 * @property {string} related_post_ids - related_post_ids
 * @return {LogObject<postModerationStatusParams>} LogObject<postModerationStatusParams>
 */
export function postModerationStatus(params) {
    return { evid: 447, src: 69, endpoint: 'blog-app-users', params: params };
}
/**
 * A function to create a log object for the 'widgetAddClickAppBuilder' event (evid: 701)
 *
 * Event description: user clicks to add widget
 *
 * @param {widgetAddClickAppBuilderParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo - is_demo
 * @property {string} screen_name - screen_name
 * @property {string} widget_id - widget_id
 * @property {GUID} id - unique widget id to connect to other events
 * @property {GUID} post_stable_id - post_stable_id
 * @property {string} origin - Add Panel/6th button
 * @property {string} element_type - recent post, custom feed, wix code
 * @property {GUID} msid - msid
 * @return {LogObject<widgetAddClickAppBuilderParams>} LogObject<widgetAddClickAppBuilderParams>
 */
export function widgetAddClickAppBuilder(params) {
    return { evid: 701, src: 69, endpoint: 'blog-app-users', params: params };
}
//# sourceMappingURL=index.js.map